import React, { useEffect } from 'react'
import DataTable from '../datatable'
import { useState } from 'react'
import { PAGINATION_DEFAULT, trainingStatusConfig } from '../../utils/constants'
import {
  useDeleteTraining,
  useGetemployeeTrainings,
} from '../../redux/employees/hook/training'
import ViewTrainingResults from '../modal/hr-section/employee-training/ViewTrainingResults'

const TrainingOverviewTab = () => {
  useEffect(() => {}, [])

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const [viewResults, setViewResults] = useState(false)
  const [trainingData, setTrainingData] = useState(null)
  const [tableType, setTableType] = useState('training')

  const switchFunction = () => {
    if (tableType === 'training') {
      setTableType('table')
    } else {
      setTableType('training')
    }
  }

  const { mutateAsync: deleteTraining } = useDeleteTraining()

  const { data: trainings } = useGetemployeeTrainings(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Training Name', 'Training Period', 'Submissions', 'Status'],
    keys: ['module_name', 'period', 'submissions', 'status'],
    mobileHeader: {
      left: {
        title: 'Training Name',
        key: 'module_name',
      },
      right: {
        title: 'Status',
        key: 'status',
      },
    },
  }

  const actionConfig = [
    {
      name: 'View',
      color: 'green',
      action: (id) => {
        let index = trainings.data.findIndex((item) => item.id === id)
        setTrainingData(trainings.data[index])
        setViewResults(true)
      },
    },
    {
      name: 'Delete',
      color: 'red',
      action: async (id) => {
        let index = trainings.data.findIndex((item) => item.id === id)
        await deleteTraining(trainings.data[index].id)
      },
    },
  ]

  return (
    <div className='flex flex-col'>
      {viewResults && (
        <ViewTrainingResults
          isOpen={viewResults}
          closeModal={() => setViewResults(false)}
          trainingData={trainingData}
        />
      )}

      <hr className='divider mt-2 mb-1' />
      <DataTable
        data={trainings}
        tableConfig={tableConfig}
        statusConfig={trainingStatusConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        filterByStatus={true}
        computedActions={true}
        tableType={tableType}
        switchFunction={switchFunction}
        layoutSwitch={true}
        searchData={true}
        noCheck={true}
      />
    </div>
  )
}

export default TrainingOverviewTab
